const sectionBBehaviors = [
    {
        behaviorKey: "feeding_foraging_drinking",
        title: "Feeding/foraging/drinking",
        color: "rgb(0, 114, 178)",
        hasDescription: true,
        hasLocation: false,
        hasAssociatedAnimals: false,
        showtags: true,
    },
    {
        behaviorKey: "vigilant",
        title: "Vigilant",
        color: "rgb(148, 103, 189)",
        hasDescription: true,
        hasLocation: false,
        hasAssociatedAnimals: false,
        showtags: true,
    },
    {
        behaviorKey: "locomotion",
        title: "Locomotion",
        color: "rgb(230, 159, 0)",
        hasDescription: true,
        hasLocation: false,
        hasAssociatedAnimals: false,
        showtags: true,
    },
    {
        behaviorKey: "self_maintenance",
        title: "Self maintenance",
        color: "rgb(51, 34, 136)",
        hasDescription: true,
        hasLocation: false,
        hasAssociatedAnimals: false,
        showtags: true,
    },
    {
        behaviorKey: "social_affiliative",
        title: "Social: Affiliative",
        color: "rgb(204, 121, 167)",
        hasDescription: true,
        hasLocation: false,
        hasAssociatedAnimals: true,
        showtags: true,
    },
    {
        behaviorKey: "parent_offspring_interaction",
        title: "Social: Parent/offspring interaction",
        color: "rgb(170, 68, 153)",
        hasDescription: true,
        hasLocation: false,
        hasAssociatedAnimals: true,
        showtags: true,
    },
    {
        behaviorKey: "social_play",
        title: "Social: Play",
        color: "rgb(0, 158, 115)",
        hasDescription: true,
        hasLocation: false,
        hasAssociatedAnimals: true,
        showtags: true,
    },
    {
        behaviorKey: "social_agonistic",
        title: "Social: Agonistic",
        color: "rgb(214, 39, 40)",
        hasDescription: true,
        hasLocation: false,
        hasAssociatedAnimals: true,
        showtags: true,
    },
    {
        behaviorKey: "social_reproductive",
        title: "Social: Reproductive",
        color: "rgb(153, 153, 51)",
        hasDescription: true,
        hasLocation: false,
        hasAssociatedAnimals: true,
        showtags: true,
    },
    {
        behaviorKey: "resting",
        title: "Resting",
        color: "rgb(102, 51, 0)",
        hasDescription: true,
        hasLocation: false,
        hasAssociatedAnimals: false,
        showtags: true,
    },
    {
        behaviorKey: "interact_with_environment",
        title: "Interaction with environment",
        color: "rgb(86, 180, 233)",
        hasDescription: true,
        hasLocation: false,
        hasAssociatedAnimals: false,
        showtags: true,
    },
    {
        behaviorKey: "object_play",
        title: "Object play",
        color: "rgb(44, 160, 44)",
        hasDescription: true,
        hasLocation: false,
        hasAssociatedAnimals: false,
        showtags: true,
    },
    {
        behaviorKey: "stereotyping",
        title: "Stereotypy",
        color: "rgb(68, 68, 68)",
        hasDescription: true,
        hasLocation: true,
        hasAssociatedAnimals: false,
        showtags: true,
    },
];

export { sectionBBehaviors };
